(function () {
  if (window.setInOneDeferredMenuImagesInit) return;
  window.setInOneDeferredMenuImagesInit = true;

  function loadDeferredMenuImages(container) {
    if (!container) return;

    container.querySelectorAll('.navmenu-item__image[data-src]').forEach(function (img) {
      if (img.dataset.loaded === 'true') return;

      img.setAttribute('src', img.getAttribute('data-src'));

      if (img.getAttribute('data-srcset')) {
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
      }

      img.dataset.loaded = 'true';
    });
  }

  function loadFromTarget(target) {
    var parent = target.closest('[data-navmenu-parent], details[data-navmenu-details]');
    if (!parent) return;
    loadDeferredMenuImages(parent);
  }

  function bindDeferredMenuImages() {
    document.querySelectorAll('details[data-navmenu-details]').forEach(function (menu) {
      menu.addEventListener('toggle', function () {
        if (menu.open) {
          loadDeferredMenuImages(menu.closest('[data-navmenu-parent]') || menu);
        }
      });
    });

    document.addEventListener('mouseover', function (event) {
      loadFromTarget(event.target);
    });

    document.addEventListener('focusin', function (event) {
      loadFromTarget(event.target);
    });

    document.addEventListener('click', function (event) {
      loadFromTarget(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDeferredMenuImages);
  } else {
    bindDeferredMenuImages();
  }
})();